import React from 'react';

import { useMapSignalR } from '../hooks/useMapSignalR';
import { useSeismicStore } from '../stores/useSeismicStore';

export const MapSignalRWatcher = () => {

    const dataGeometryLine = useSeismicStore(state => state.geometryLine);
    useMapSignalR(dataGeometryLine);

    return (
        <React.Fragment></React.Fragment>
    );
};